import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleRoundHyperstarOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M8 .5c.56 0 1.119.028 1.667.085v1.407A15 15 0 0 0 8 1.9c-1.878 0-3.604.327-4.809 1.011-1.118.636-1.79 1.565-1.79 3.044 0 1.408.607 2.304 1.6 2.93 1.072.676 2.628 1.043 4.387 1.112l1.345.053v2.63l.28-.203c.94-.68 1.894-1.383 2.757-2.13 1.638-1.417 2.635-2.739 2.802-4.014h1.41c-.267 3.022-3.665 5.482-6.422 7.477l-.827.601a25 25 0 0 0-1.4 1.089v-4.103C3.567 11.249 0 9.817 0 5.954 0 1.865 4 .5 8 .5"
                        fill="currentColor"
                    />
                    <path d="M11.33 6.7H4.665V5.298h6.665z" fill="currentColor" />
                    <path
                        d="M13.5 0A9.5 9.5 0 0 0 16 2.5 9.5 9.5 0 0 0 13.5 5 9.5 9.5 0 0 0 11 2.5 9.5 9.5 0 0 0 13.5 0"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
BubbleRoundHyperstarOutlinedSize16Glyph.displayName = 'BubbleRoundHyperstarOutlinedSize16Glyph';
